import { FilterOptions } from "../../Helpers/Constants";
import { ProjectSummary } from "../../Models/ProjectSummary";

export interface IProjectListState {
  originalProjectList: ProjectSummary[];
  projectsList: ProjectSummary[];
  loaded: boolean;
  errorCode: string | null | undefined;
  filter?: FilterOptions;
  searchTerm?: string;
}

export const initialProjectListState: IProjectListState = {
  projectsList: [] as ProjectSummary[],
  originalProjectList: [] as ProjectSummary[],
  loaded: false,
  errorCode: null,
  filter: FilterOptions.None,
  searchTerm: undefined,
};
